import { SVGProps } from "react";

export type TargetProps = SVGProps<SVGSVGElement>;

const Target: React.FC<TargetProps> = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.28496 12.7339C5.28496 18.0496 11.7401 20.7203 15.4968 16.9634C17.4778 14.9825 17.7989 11.9222 16.36 9.59292L14.2133 11.7396C14.8911 13.743 13.4035 15.8437 11.2671 15.8437C8.51195 15.8437 7.10944 12.4969 9.06989 10.5365L9.06802 10.5346C9.91996 9.68267 11.1613 9.41585 12.2623 9.78658L14.408 7.64089C10.4555 5.19923 5.28494 8.03594 5.28494 12.7337L5.28496 12.7339ZM19.9982 6.0692L18.8916 6.08605L12.8775 12.0991C13.5553 13.8395 11.3618 15.2736 10.0437 13.9565C9.36684 13.2796 9.36964 12.1806 10.0418 11.5084L10.0437 11.5102C10.5389 11.015 11.2701 10.8755 11.9002 11.1236L17.9143 5.10956L17.9312 4.00301C17.9349 3.76803 18.0201 3.56769 18.1858 3.40199L20.5235 1.06437C20.662 0.925816 20.8979 1.02599 20.8942 1.22165L20.8642 3.13612L22.7788 3.10616C22.9744 3.10335 23.0737 3.33927 22.936 3.47689L20.5984 5.81451C20.4336 5.98115 20.2323 6.06546 19.9982 6.0692ZM1 12.7339C1 10.106 2.00266 7.47912 4.00707 5.47389C7.58431 1.89673 13.1949 1.48403 17.2354 4.37857L17.2288 4.82046L15.4051 6.64412C10.5612 3.34401 3.90408 6.80514 3.90504 12.7339C3.90504 16.8007 7.20138 20.096 11.2673 20.096C17.1961 20.096 20.6574 13.439 17.3581 8.59519L19.1818 6.77152L19.6237 6.76497C20.8979 8.54464 21.5354 10.6388 21.5354 12.733C21.5354 18.4033 16.9387 23 11.2682 23C5.59678 23.0009 1 18.4042 1 12.7339Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Target;
